import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { ToolService } from '../../services/tool.service';
import { of, Subscription, switchMap } from 'rxjs';
import { ApiConfiguration, RouterService } from '../../public-api';
import { ModalController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';

@Component({
  selector: 'lib-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  constructor(
    public state: StateService,
    private routerService: RouterService,
    private tools: ToolService,
    private base: ApiConfiguration,
    private modalController: ModalController
  ) {}
  subs: Subscription[] = [];
  username: string;
  password: string;
  loader: HTMLIonLoadingElement;
  errorMessage: string;
  private tapCount = 0;
  private lastTap = 0;

  async ngOnInit() {
    let topModal = await this.modalController.getTop();
    if (topModal) {
      // Needed if the token is oudated, the app routes to login but there was a modal opened
      await topModal.dismiss();
    }
    this.username = await this.state.readFromSecureStorage(
      this.state.USERNAMEKEY
    );

    // can be deleted after all user have min v5.3
    await this.cleanAllKeys();

    if (this.password) {
      console.log('Password found');
      await this.login();
    } else {
      console.log('No password found, try token login');
      await this.state.ensureTokenIsValid();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
  }

  switch() {
    this.tools.showInfoToast('Switching to staging..');
    this.base.rootUrl = 'https://baulogistik-staging.azurewebsites.net';
    this.state.performHealthCheck();
  }

  onTap() {
    const now = Date.now();
    if (now - this.lastTap > 400) {
      this.tapCount = 1;
    } else {
      this.tapCount++;
    }
    this.lastTap = now;

    if (this.tapCount === 3) {
      this.tapCount = 0;
      this.switch();
    }
  }

  async saveCredentials() {
    await this.state.saveToSecureStorage(this.state.USERNAMEKEY, this.username);
  }

  async login() {
    await this.saveCredentials();
    this.errorMessage = '';
    this.subs.push(
      this.state
        .authenticate(this.username, this.password)
        .pipe(
          switchMap(async (x) => {
            if (x != null) {
              await this.state.processAuthResult(x);
              return this.state.loadRole();
            } else {
              this.errorMessage = 'Anmeldedaten leider nicht korrekt';
              return of(null);
            }
          })
        )
        .subscribe({
          next: (x) => {
            this.routerService.routeToHome();
          },
          error: (err) => {
            this.state.handleError(err);
          },
        })
    );
  }

  async cleanAllKeys(): Promise<void> {
    let migrationState = await this.state.readFromSecureStorage(
      'KeyMigrationDone'
    );
    if (migrationState == 'true') return;
    const { keys } = await Preferences.keys();
    if (keys == null || keys.length == 0) return;

    for (const key of keys) {
      console.log(key);
      if (key.startsWith('pdfjs')) {
        continue;
      }
      const { value } = await Preferences.get({ key });
      if (key.startsWith('PASSWORD')) {
        this.password = value;
      }

      if (key.startsWith('USERNAME')) {
        this.username = value;
      }

      if (value !== null) {
        await Preferences.remove({ key });
        console.log(`Removed: ${key}`);
      }
    }
    await this.state.saveToSecureStorage('KeyMigrationDone', 'true');
  }
}
